module.exports = __webpack_public_path__ + "img/about-us.f05b013e.png";